export default __webpack_public_path__ + "static/media/taskEmpty.7ea4326b.svg";